import React, {useEffect, useMemo, useState} from 'react';
import {Empty} from 'antd';
import {Column} from '@ant-design/plots';

interface UserActivityProps {
  stats: any[];
}

//transformStats check if change colours sequence, data also should be aligned with it
export const defaultColors = {
  //those 4 only present in user stats
  invites: '#5cb85c',
  followups: '#fdbe00',
  responses: '#d60093',
  inmail: '#c197ef',

  // those 2 are the same one
  // we do not show it for some reason
  // but it s present in network response
  // nurtured: '#98d9d9',
  // nurture: '#98d9d9',
};
export const defaultColorsValues = Object.values(defaultColors);
const defaultColorsKeys = Object.keys(defaultColors);

export const UserActivityChart: React.FC<UserActivityProps> = ({stats}) => {
  const [chartData, setChartData] = useState<any[]>([]);

  const transformedData = useMemo(() => {
    if (!stats?.length) {
      return [];
    }

    return stats.reduce((acc, item) => {
      defaultColorsKeys.forEach(key => {
        if (item[key] !== undefined) {
          acc.push({
            day: item.day,
            name: key,
            // activityType: key === 'nurture' ? 'nurtured' : key,
            value: item[key],
          });
        }
      });
      return acc;
    }, []);
  }, [stats]);

  useEffect(() => {
    setChartData(transformedData);
  }, [transformedData]);

  const config = useMemo(() => {
    return {
      data: chartData,
      isGroup: true,
      xField: 'day',
      yField: 'value',
      colorField: 'name',
      seriesField: 'name',
      groupField: 'name',
      title: false,
      label: false,
      legend: false,
      autoFit: true,
      height: 70,
      width: 300,
      padding: [0, 0, 0, 0],
      scale: {
        color: {
          range: defaultColorsValues,
        },
      },
      axis: {
        x: null,
        y: null,
      },
    };
  }, [chartData]);

  return chartData.length > 0 ? (
    <Column {...config} />
  ) : (
    <Empty
      description="No latest activity"
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      styles={{image: {marginLeft: '20px'}}}
      style={{margin: '10px 0', textAlign: 'left'}}
    />
  );
};
